var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_287_1027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.933228 7.70302C0.933228 7.70302 3.59989 2.36969 8.26656 2.36969C12.9332 2.36969 15.5999 7.70302 15.5999 7.70302C15.5999 7.70302 12.9332 13.0364 8.26656 13.0364C3.59989 13.0364 0.933228 7.70302 0.933228 7.70302Z",
    stroke: "#123051",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26624 9.70294C9.37081 9.70294 10.2662 8.80751 10.2662 7.70294C10.2662 6.59837 9.37081 5.70294 8.26624 5.70294C7.16167 5.70294 6.26624 6.59837 6.26624 7.70294C6.26624 8.80751 7.16167 9.70294 8.26624 9.70294Z",
    stroke: "#123051",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_287_1027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white",
    transform: "translate(0.266235 0.702942)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.7d37772796fcd1620e30e48cbd8e06b2.svg";
export { ForwardRef as ReactComponent };